<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'deviceInstantiationGroupName'
        label= '设备组'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'
        width= '180'>
      </el-table-column>
      <el-table-column
        prop= 'deviceSerial'
        label= '序列号'
        width= '120'>
      </el-table-column>
      <el-table-column
        prop= 'type'
        label= '类别'
        width= '140'>
        <template slot-scope='scope'>
          <el-button type='primary' size='mini' v-if="scope.row.type===10">常规</el-button>
          <el-button type='info' size='mini' v-if="scope.row.type===20">全景</el-button>
          <el-button type='success' size='mini' v-if="scope.row.type===30">可旋转</el-button>
          <el-button type='warn' size='mini' v-if="scope.row.type===40">可旋转焦距可调</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'channelNo'
        label= '通道号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'channelName'
        label= '通道名'
        width= '320'>
      </el-table-column>
      <el-table-column
        prop= 'isEncrypt'
        label= '加密类别'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.isEncrypt===1">加密</el-button>
          <el-button type='info' size='small' v-if="scope.row.isEncrypt===0">未加密</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'videoLevel'
        label= '视频质量'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='primary' size='small' v-if="scope.row.videoLevel===0">流畅</el-button>
          <el-button type='warn' size='small' v-if="scope.row.videoLevel===1">均衡</el-button>
          <el-button type='success' size='small' v-if="scope.row.videoLevel===2">高清</el-button>
          <el-button type='danger' size='small' v-if="scope.row.videoLevel===3">超清</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'outNetUrl'
        label= '外网地址'>
      </el-table-column>
      <el-table-column
        prop= 'status'
        label= '在线状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='info' size='small' v-if="scope.row.status===0">离线</el-button>
          <el-button type='success' size='small' v-if="scope.row.status===1">在线</el-button>
        </template>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '240'>
        <template slot-scope='scope'>
          <el-button @click='manageCameraPic(scope.row)' type='text' size='small' style="color: #209323">抓拍管理</el-button>
          <el-button @click='manageCameraPos(scope.row)' type='text' size='small' style="color: #209323">预置点管理</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="true" top="0">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="设备组ID" :label-width="formLabelWidth" prop="deviceInstantiationGroupId">
          <el-select v-model="form.deviceInstantiationGroupId" placeholder="请选择">
            <el-option v-for="item in groups" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备帐号" :label-width="formLabelWidth" prop="username">
              <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备密码" :label-width="formLabelWidth" prop="password">
              <el-input v-model="form.password" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="验证码" :label-width="formLabelWidth" prop="valiCode">
              <el-input v-model="form.valiCode" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备序列号" :label-width="formLabelWidth" prop="deviceSerial">
              <el-input v-model="form.deviceSerial" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="视频质量" :label-width="formLabelWidth" prop="videoLevel">
              <el-radio v-model="form.videoLevel" :label=0>流畅</el-radio>
              <el-radio v-model="form.videoLevel" :label=1>均衡</el-radio>
              <el-radio v-model="form.videoLevel" :label=2>高清</el-radio>
              <el-radio v-model="form.videoLevel" :label=3>超清</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加密类型" :label-width="formLabelWidth" prop="isEncrypt">
              <el-radio v-model="form.isEncrypt" :label=1>加密</el-radio>
              <el-radio v-model="form.isEncrypt" :label=0>未加密</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="截屏间隔" :label-width="formLabelWidth" prop="captureTime">
              <el-input v-model="form.captureTime" autocomplete="off" placeholder="0：表示不用截屏"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="通道号" :label-width="formLabelWidth" prop="channelNo">
              <el-input type="number" v-model.number="form.channelNo" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通道名" :label-width="formLabelWidth" prop="channelName">
              <el-input v-model="form.channelName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="类别" :label-width="formLabelWidth" prop="type">
          <el-radio v-model="form.type" :label=10>常规</el-radio>
          <el-radio v-model="form.type" :label=20>全景</el-radio>
          <el-radio v-model="form.type" :label=30>可旋转</el-radio>
          <el-radio v-model="form.type" :label=40>可旋转焦距可调</el-radio>
        </el-form-item>
        <el-form-item label="内网地址" :label-width="formLabelWidth" prop="intraNetUrl">
          <el-input v-model="form.intraNetUrl" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="外网地址" :label-width="formLabelWidth" prop="outNetUrl">
          <el-input v-model="form.outNetUrl" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="经纬度坐标" :label-width="formLabelWidth">
          <div id="container" style="width:100%;height:500px;"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="curRow.name + '  抓拍管理管理'" :visible.sync="dialogCameraPicVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <cameraPic :cameraId="curRow.id"></cameraPic>
    </el-dialog>
    <el-dialog :title="curRow.name + '  预置点管理'" :visible.sync="dialogCameraPosVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <cameraPos :cameraId="curRow.id"></cameraPos>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import AMapLoader from '@amap/amap-jsapi-loader'
import cameraPic from '../cameraPic/Index.vue'
import cameraPos from '../cameraPos/Index.vue'
export default {
  components: {
    cameraPic,
    cameraPos
  },
  props: {
    deviceInstantiationGroupId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data () {
    return {
      curRow: {},
      tableData: [],
      name: '',
      dialogFormVisible: false,
      dialogCameraPicVisible: false,
      dialogCameraPosVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        username: null,
        password: null,
        name: null,
        valiCode: null,
        deviceSerial: null,
        intraNetUrl: null,
        outNetUrl: null,
        type: null,
        channelNo: null,
        channelName: null,
        isEncrypt: null,
        videoLevel: null,
        status: 0,
        deviceInstantiationGroupId: null,
        organizationId: null,
        captureTime: null,
        lng: null,
        lat: null
      },
      rules: {
        type: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '类别 不能为空', trigger: ['change', 'blur'] }],
        channelNo: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '通道号 不能为空', trigger: ['change', 'blur'] }],
        isEncrypt: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '是否加密 不能为空', trigger: ['change', 'blur'] }],
        videoLevel: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '视频质量 不能为空', trigger: ['change', 'blur'] }],
        status: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '在线状态 不能为空', trigger: ['change', 'blur'] }],
        deviceInstantiationGroupId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '设备组ID 不能为空', trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      groups: []
    }
  },
  watch: {
    deviceInstantiationGroupId: {
      handler (newV, oldV) {
        this.form.deviceInstantiationGroupId = this.deviceInstantiationGroupId
        this.query()
      },
      immediate: true
    }
  },
  created () {
    this.query()
    this.queryGroup()
  },
  methods: {
    manageCameraPic (row) {
      this.curRow = row
      this.dialogCameraPicVisible = true
    },
    manageCameraPos (row) {
      this.curRow = row
      this.dialogCameraPosVisible = true
    },
    initAMap () {
      let that = this
      AMapLoader.load({
        key: 'b72c573a626158a27e4ada7a9c853665',
        version: '1.4.15',
        plugins: ['AMap.Driving', 'AMap.MapType']
      }).then((AMap) => {
        that.map = new AMap.Map('container', {
          zoom: 17,
          zooms: [2, 22],
          layers: [
            new AMap.TileLayer.Satellite(),
            new AMap.TileLayer.RoadNet()
          ]
        })
        that.map.on('click', (e) => {
          that.map.clearMap()
          that.form.lng = e.lnglat.getLng()
          that.form.lat = e.lnglat.getLat()
          let position = new AMap.LngLat(that.form.lng, that.form.lat)
          let marker = new AMap.Marker({
            position: position,
            offset: new AMap.Pixel(-13, -30)
          })
          that.map.add(marker)
        })
        if (that.form.lng && that.form.lat) {
          let position = new AMap.LngLat(that.form.lng, that.form.lat)
          that.map.setCenter([that.form.lng, that.form.lat])
          let marker = new AMap.Marker({
            position: position,
            offset: new AMap.Pixel(-13, -30)
          })
          that.map.add(marker)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/camera/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/camera/listPage?current=${that.current}&pageSize=${that.pageSize}&deviceInstantiationGroupId=${that.deviceInstantiationGroupId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
        for (let item of that.tableData) {
          for (let group of that.groups) {
            if (item.deviceInstantiationGroupId === group.id) {
              item.deviceInstantiationGroupName = group.name
            }
          }
        }
      })
    },
    queryGroup () {
      let that = this
      requestService.get(`/deviceInstantiationGroup/listPage?current=1&pageSize=6553500`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.groups = res.data.body.records
        for (let item of that.tableData) {
          for (let group of that.groups) {
            if (item.deviceInstantiationGroupId === group.id) {
              item.deviceInstantiationGroupName = group.name
            }
          }
        }
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
      this.initAMap()
    },
    digAdd () {
      this.form = {deviceInstantiationGroupId: this.deviceInstantiationGroupId, status: 0}
      this.dialogFormVisible = true
      this.initAMap()
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/camera/add'
          if (that.form.id) {
            url = '/camera/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/camera/Index.vue